const settingsCalls = {
  async account_settings({ dispatch }) {
    return dispatch('api_call', {
      endpoint: 'account/settings/',
      hasCancel: false,
      mutation: 'api_account_settings',
      action: 'combineUserSettings',
    })
  },
  async account_settings_user_only({ dispatch }) {
    return dispatch('api_call', {
      method: 'get',
      endpoint: 'account/settings/',
      hasCancel: false,
      mutation: 'api_account_settings',
      action: 'settingsUpdateUserInfo',
    })
  },
  async account_settings_patch({ dispatch }, { data }) {
    return dispatch('api_call', {
      method: 'patch',
      endpoint: 'account/settings/',
      mutation: 'api_account_settings',
      action: 'combineUserSettings',
      message: {
        type: 'error',
      },
      data,
    })
  },

  async api_gameformat_favorite({ dispatch }, { id, is_favorite }) {
    const endpoint = `poker/game-modes/${id}/${is_favorite ? 'favorite' : 'unfavorite'}/`
    // console.log({ id, favorite }, endpoint)
    const res = await dispatch('api_call', {
      method: 'POST',
      endpoint,
      hasCancel: false,
      message: {
        type: 'error',
      },
    })
    // return { res: { error: { response: { status: 500 } } }, args: { id, is_favorite } }
    return { res, args: { id, is_favorite } }
  },
}

export default settingsCalls
